module.exports = __webpack_public_path__ + "img/commissionDomonetization.1a38d9d9.svg";